/*
 * Edible Beauty cart — <cart-drawer> and <cart-drawer-items> (Dawn-compatible API:
 * open(), close(), renderContents(parsedState), getSectionsToRender()).
 */
(function () {
  'use strict';

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      /* Overlay lives inside #CartDrawer and is replaced on every render, so delegate. */
      this.addEventListener('click', (evt) => {
        if (evt.target && evt.target.id === 'CartDrawer-Overlay') this.close();
      });
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const bubble = document.querySelector('#cart-icon-bubble');
      const cartLink = bubble ? bubble.closest('a') || bubble : null;
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      /* With Alpine present the legacy header handler opens the drawer via the bridge. */
      if (!window.Alpine) {
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
      }
      cartLink.addEventListener('keydown', (event) => {
        if (event.code && event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      if (this.classList.contains('active')) return;

      setTimeout(() => this.classList.add('animate', 'active'));

      this.addEventListener(
        'transitionend',
        () => {
          const container = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty') || document.getElementById('CartDrawer')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          window.trapFocus(container, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
      this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    }

    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      window.removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      this.dispatchEvent(new CustomEvent('cart-drawer:close', { bubbles: true }));
    }

    /* Dawn API used by apps: pass the JSON returned by /cart/add.js with `sections`. */
    renderContents(parsedState) {
      window.EBCart.refresh({
        source: 'cart-drawer',
        sections: parsedState && parsedState.sections,
        wasItemAdded: true,
      })
        .catch(() => {})
        .then(() => this.open());
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  class CartDrawerItems extends window.CartItems {
    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }
  }

  if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
})();
